import React from "react";
import "./InputBox.scss";

const InputBox = ({
  customClass,
  type,
  name,
  placeHolder,
  value,
  onChange,
  checked,
  autocomplete,
}) => {
  return (
    <input
      className={`InputBox ${customClass}`}
      type={type}
      placeholder={placeHolder}
      value={value}
      onChange={onChange}
      name={name}
      checked={checked}
      autocomplete={autocomplete}
    />
  );
};

export default InputBox;
